<template>
    <el-menu
            mode="vertical"
            :default-active="$route.path"
            router
            class="AsideHeader"
            :class="{ 'AsideHeader--menuOpened': menuOpened }"
    >
        <div class="AsideHeader-routes" v-if="saisit_en_ligne && !isBailleurSocial">

            <router-link :to="{ name: 'post-new' }" class="routerLink">
                <el-menu-item index="/posts/new" class="Route" @click="eventAnalytics('creation_annonce')">
                  <el-tooltip effect="dark" placement="top-start" content="Créer une Annonce" v-if="!widthDesktop">
                    <ubi-icon name="announcement" class="Route-icon"/>
                  </el-tooltip>
                  <ubi-icon name="announcement" class="Route-icon" v-else/>

                  <span class="Route-title">{{ createPostTitle }}</span>
                </el-menu-item>
            </router-link>

            <el-divider direction="vertical" v-if="browserContext.up('xl')"/>

            <router-link :to="{ name: 'nousContacter' }" class="routerLink">
                <el-menu-item index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                  <el-tooltip effect="dark" placement="top-start" content="Nous contacter" v-if="!widthDesktop">
                    <ubi-icon name="email" class="Route-icon"/>
                  </el-tooltip>
                  <ubi-icon name="email" class="Route-icon" v-else/>
                  <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                </el-menu-item>
            </router-link>
            <el-divider direction="vertical" v-if="browserContext.up('xl')" />

<!--            VIDEO -->
            <router-link :to="{name : 'tutoralsVideos'}" class="routerLink">
              <el-menu-item index="/tutoralsVideos?theme=1" class="Route" @click="eventAnalytics('tutoralsVideos')">
                <el-tooltip effect="dark" placement="right" content="Nouvelle video" v-if="!widthDesktop">
                  <ubi-icon name="help" class="Route-icon"/>
                </el-tooltip>
                <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
              </el-menu-item>
            </router-link>
        </div>

        <div class="AsideHeader-routes" style="position: absolute;left: 75px" v-else>
            <router-link :to="{ name: 'nousContacter' }" class="routerLink">
                <el-menu-item index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                  <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                    <ubi-icon name="email" class="Route-icon"/>
                  </el-tooltip>
                  <ubi-icon name="email" class="Route-icon" v-else/>
                    <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                </el-menu-item>
            </router-link>

            <el-divider direction="vertical" v-if="browserContext.up('xl')" />

            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (VO).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-if="sitimmoUser.univers == 'VO'">
              <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                <ubi-icon name="help" class="Route-icon"/>
              </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (CMI).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-else-if="sitimmoUser.metier == 'CMI'">
              <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                <ubi-icon name="help" class="Route-icon"/>
              </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (promotion).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-else-if="sitimmoUser.metier == 'PROMOTEUR'">
                <<el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
              <ubi-icon name="help" class="Route-icon"/>
            </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (bailleurs sociaux).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-else-if="sitimmoUser.metier == 'BAILLEUR_SOCIAL' && !isUSH">
              <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                <ubi-icon name="help" class="Route-icon"/>
              </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (bailleurs sociaux USH).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-else-if="sitimmoUser.metier == 'BAILLEUR_SOCIAL' && isUSH">
              <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                <ubi-icon name="help" class="Route-icon"/>
              </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
            <a class="Route" href="/docs/Espace client Ubiflow - note d_utilisation (immo ancien).pdf" @click="eventAnalytics('aide')" target="_blank" rel="noopener" v-else>
              <el-tooltip effect="dark" placement="top-start" content="Aide" v-if="!widthDesktop">
                <ubi-icon name="help" class="Route-icon"/>
              </el-tooltip>
              <ubi-icon name="help" class="Route-icon" v-else/>
                <span class="Route-title">{{ $t("layouts.help") }}</span>
            </a>
        </div>
    </el-menu>
</template>

<script>
import { Divider, Menu, MenuItem } from 'element-ui'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'AsideHeader',
  inject: ['browserContext'],
  props: ['widthDesktop'],
  components: { ElDivider: Divider, ElMenu: Menu, ElMenuItem: MenuItem },
  data () {
    return {
      saisieEnLigne: false
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    saisit_en_ligne () {
      return this.sitimmoUser.saisit_annonces_en_ligne
    },
    menuOpened () {
      return this.$store.getters.getMenuOpened
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isUSH () {
      return this.$store.getters.getUser.isUSH
    },
    createPostTitle () {
      if (this.isPromoteur) {
        return this.$t('layouts.create_program')
      }
      return this.$t('layouts.createAd')
    }
  },
  methods: {
    ...mapMutations('postsListImmo', ['SET_ANNONCE_PARENTE']),
    sendEmail () {
      window.location = 'mailto:relation.client@ubiflow.net'
    },
    eventAnalytics (category) {
      if (this.isPromoteur) {
        this.SET_ANNONCE_PARENTE(null)
      }
      this.$ga.event('navigation_permanente', 'clic', category, this.sitimmoUser.id)
    }
  }
}
</script>

<style lang="scss">
    @import "@/theme/_bootstrap.scss";

    .AsideHeader {
        border-right: 0;
        height: 128px;
        overflow-x: hidden;

        .routerLink{
            text-decoration: none;
        }

        .el-divider {
            background: $gray-600;
            height: map-get($spacers, 4);
        }

        .Route {
            font-size: $font-size-base;
            color: $white;
            background: transparent;
            height: 52px;

            &-title {
                @extend .font-secondary;
                font-size: $font-size-sm-alt;
            }

            &-icon {
                color: $yellow !important;
                font-size: $font-size-base * 1.5;
                transition: color 0.3s;
            }
        }

        @include media-breakpoint-up(xl) {
            border-right: 0 !important;
            padding-left: map-get($spacers, 4);
            padding-right: map-get($spacers, 4);

            &-routes {
                align-items: center;
                display: flex;
                flex-direction: row;
                height: 100%;
                justify-content: space-evenly;

                .Route {
                    align-items: center;
                    background: transparent;
                    display: flex;
                    flex-direction: column;
                    font-weight: lighter;
                    height: 55px;
                    justify-content: flex-start;
                    line-height: $font-size-base-alt;
                    padding: 0 !important;
                    position: relative;
                    text-align: center;
                    text-decoration: none;
                    white-space: initial;
                    width: 90px;
                    font-size: $font-size-sm-alt;

                    &-title {
                        margin-top: map-get($spacers, 2);
                    }

                    &::before {
                        content: "";
                        background: rgba(255, 255, 255, 0.07);
                        border-radius: 100%;
                        display: block;
                        height: 0;
                        width: 100px;
                        left: 50%;
                        position: absolute;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        transition: width 0.3s, height 0.3s;
                    }

                    &:hover {
                        color: $yellow;
                        text-decoration: none;

                        &::before {
                            height: 100px;
                            width: 100px;
                        }
                    }
                }
            }
        }

        @include media-breakpoint-down(lg) {
            background: $black !important;
            display: flex;
            flex-direction: column;
            justify-content: center;

            &-routes {
                text-align: center;

                .Route {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                    height: 44px;

                    &-title {
                        display: inline-block;
                        font-size: $font-size-base-alt;
                        line-height: initial;
                        margin-left: map-get($spacers, 0);
                        overflow: hidden;
                        text-align: left;
                        transition: width 0.3s, margin-left 0.3s;
                        width: 0;
                    }

                    &::before {
                        content: "";
                        border-bottom: 1px solid $yellow;
                        width: 0;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transition: width 0.3s;
                    }

                    &.is-active,
                    &:hover {
                        .Route-icon {
                            color: $yellow;
                        }

                        &::before {
                            width: map-get($spacers, 2);
                        }
                    }
                }
            }
        }

        &--menuOpened {
            .Route {
                &-title {
                    margin-left: map-get($spacers, 3);
                    width: 220px;
                }

                &.is-active,
                &:hover {
                    &::before {
                        width: map-get($spacers, 3);
                    }
                }
            }
        }
    }
</style>
